module.exports = __webpack_public_path__ + "img/sup_login_2.c07057ae.png";